import React, { useEffect, useState } from 'react';
import useSiteIcon from '../hooks/useSiteIcon';

/**
 * Icono de un sitio (proxy de iconos). Mientras no hay icono, o si el ajuste esta apagado, o si falla,
 * se pinta `fallback` (las iniciales / el icono de tipo de siempre).
 */
function SiteIcon({ url, className, fallback = null }) {
  const src = useSiteIcon(url);
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);
  if (!src || broken) return fallback;
  return <img src={src} alt="" className={className} onError={() => setBroken(true)} />;
}

export default SiteIcon;
